<div class="layout">
  <p-drawer [(visible)]="sidebarVisible" [modal]="false" styleClass="layout-sidebar">
    <ng-template #header>
      <img src="innision-logo.png" alt="Innision" class="sidebar-logo" />
    </ng-template>

    <nav class="sidebar-nav">
      <a routerLink="/dashboard" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
        <i class="pi pi-home"></i>
        <span>Dashboard</span>
      </a>
      <a routerLink="/sdr-agent" routerLinkActive="active-link" class="nav-item">
        <i class="pi pi-bolt"></i>
        <span>SDR Agent</span>
      </a>
    </nav>
  </p-drawer>

  <div class="layout-main" [class.sidebar-open]="sidebarVisible()">
    <p-toolbar styleClass="layout-header">
      <ng-template #start>
        <p-button
          icon="pi pi-bars"
          [text]="true"
          (onClick)="toggleSidebar()"
        />
      </ng-template>

      <ng-template #end>
        <span class="user-name">{{ authService.user()?.displayName ?? authService.user()?.email }}</span>
        <p-button
          icon="pi pi-sign-out"
          label="Logout"
          [text]="true"
          (onClick)="logout()"
        />
      </ng-template>
    </p-toolbar>

    <main class="layout-content">
      <router-outlet />
    </main>
  </div>
</div>
